import subscriptionTypeUtil from '../../../../app/administrative/subscriptionCategories/subscriptionTypeUtil.ts';
import { CategoryLimits } from '../../../../app/administrative/subscriptionCategories/categoryLimits';

angular
    .module('signalview.subscriptionInfo', [])
    .constant('subscriptionTypeUtil', subscriptionTypeUtil)
    .constant('CATEGORY_LIMITS', CategoryLimits);
